import type { FunctionComponent } from 'react'

import styles from './bento-square-counter.module.scss'
import { Markdown } from '@components/markdown'
import { ActionButton } from '@contentful-components/action-button'
import type { BentoPieceSquareCounterFragment } from '@graphql/queries/GetBentoPieceSquareCounter.graphql'
import { usePersonalizations } from '@lib/hooks/usePersonalizations'
import { isGradientColor } from '@lib/utils/isGradientColor'
import { renderTemplate } from '@lib/utils/text'
import variables, { type Variable } from '@styles/variables'

export const BentoSquareCounter: FunctionComponent<Props> = ({
    smallerVersion = false,
    counter = '',
    heading = '',
    subtitle = '',
    backgroundColor = 'darkGray',
    button,
}) => {
    const personalizations = usePersonalizations()

    function getBackgroundStyle() {
        if (isGradientColor(backgroundColor)) {
            return { background: variables[backgroundColor as Variable] }
        }

        return { backgroundColor: variables[backgroundColor as Variable] }
    }

    return (
        <div className={styles.boxOne} style={getBackgroundStyle()}>
            <div className={styles.boxOneContent}>
                <div className={styles.boxOneCopy}>
                    <div
                        className={`${styles.number} ${
                            styles.headinggradient
                        } ${smallerVersion ? styles.smallerVersion : ''}`}
                    >
                        {counter}
                    </div>

                    <div className={styles.copy}>
                        <div
                            className={`${styles.heading} ${
                                smallerVersion ? styles.smallerVersion : ''
                            }`}
                        >
                            <Markdown
                                tag='h3'
                                typeStyle={{
                                    _: 'heading-xs',
                                    md: 'heading-sm',
                                }}
                                markdown={renderTemplate(
                                    heading,
                                    personalizations,
                                )}
                            />
                        </div>
                        <div className={styles.subtitle}>
                            <Markdown
                                tag='p'
                                typeStyle={{ _: 'body-lg', md: 'body-md' }}
                                markdown={renderTemplate(
                                    subtitle,
                                    personalizations,
                                )}
                            />
                        </div>
                        {button?.title && (
                            <div className={styles.button}>
                                <ActionButton {...button} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BentoSquareCounter

type Props = Omit<BentoPieceSquareCounterFragment, 'sys' | 'type'> & {
    index?: number
    button?: object
}
